import React from 'react'
import styled from '@emotion/styled'
import { Tag } from 'stylist'
import Label from './Label'

const StrikeThrough = styled.span`
  text-decoration: line-through;
`

const HeadersList = ({ headers = [], toggleHideColumn, visibleColumns }) => {
  const tags = headers.map((header, index) => {
    const id = String(index)
    return {
      text: header,
      id,
      isShown: visibleColumns.some(column => column.id === id)
    }
  })
  return (
    <div>
      <Label>Headers (click to hide/show)</Label>
      <div>
        {tags.map(tag => (
          <Tag
            key={tag.id}
            selectable
            onSelect={() => toggleHideColumn(tag.id)}
          >
            {tag.isShown ? tag.text : <StrikeThrough>{tag.text}</StrikeThrough>}
          </Tag>
        ))}
      </div>
    </div>
  )
}

export default HeadersList



// WEBPACK FOOTER //
// ./src/routes/admin/HeadersList.js